import React, { useState, useEffect } from "react";
import { useGlobalContext } from "../GlobalContext";
import "datatables.net-dt/css/dataTables.dataTables.css";
import "datatables.net";
import $ from "jquery";

const SetJasaManasuka = () => {
  const { api, isReady } = useGlobalContext();

  const [jenisManasuka, setJenisManasuka] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [showEditModal, setShowEditModal] = useState(false);

  const getJenisManasuka = async () => {
    try {
      const res = await api.get("/api/setup/manasuka/");
      const data = res.data.simpananmanasuka || [];
      setJenisManasuka(data);

      if ($.fn.DataTable.isDataTable("#example2")) {
        $("#example2").DataTable().destroy();
      }
      setTimeout(() => {
        $("#example2").DataTable({
          searching: false,
          paging: false,
          info: false,
        });
      }, 0);
    } catch (error) {
      console.error("❌ Gagal mengambil data:", error);
      setJenisManasuka([]);
    }
  };

  useEffect(() => {
    if (!isReady) return;
    getJenisManasuka();
  }, [isReady]);

  const handleEdit = (item) => {
    setSelectedItem(item);
    setEditedData(item);
    setShowEditModal(true);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSave = async () => {
    if (!selectedItem) return;

    const dataupdate = {
      simpanan: editedData.simpanan,
      jasa: isNaN(editedData.jasa) ? editedData.jasa : String(editedData.jasa),
      noperk: editedData.noperk,
    };

    try {
      await api.patch(`/api/setup/manasuka/${editedData.kode}`, dataupdate);
      alert("✅ Data berhasil diperbarui.");
      setShowEditModal(false);
      getJenisManasuka();
    } catch (error) {
      console.error("❌ Gagal memperbarui data:", error.response?.data || error.message);
      alert("Gagal memperbarui data.");
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
      <div className="row">
        <div className="col-12">
          <div className="card card-info">
            <div className="card-header">
              <h1 className="card-title"><b>SET JASA MANASUKA</b></h1>
            </div>
            <div className="card-body">
              <table width="100%" id="example2" className="table table-bordered table-hover">
                <thead>
                  <tr>
                    <th>Kode</th>
                    <th>Nama Simpanan</th>
                    <th>Jasa %</th>
                    <th>No Perk</th>
                    <th>Aksi</th>
                  </tr>
                </thead>
                <tbody>
                  {jenisManasuka.map((item, index) => (
                    <tr key={`${item.kode}-${index}`}>
                      <td>{item.kode}</td>
                      <td>{item.simpanan}</td>
                      <td>{item.jasa}</td>
                      <td>{item.noperk}</td>
                      <td>
                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() => handleEdit(item)}
                        >
                          Edit
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {/* Modal Edit */}
      {showEditModal && (
        <div className="modal fade show d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Data</h5>
                <button className="close" onClick={() => setShowEditModal(false)}>
                  &times;
                </button>
              </div>
              <div className="modal-body">
                <div className="form-group">
                  <label>Kode</label>
                  <input
                    type="text"
                    className="form-control"
                    name="kode"
                    value={editedData.kode || ""}
                    readOnly
                  />
                </div>
                <div className="form-group">
                  <label>Nama Simpanan</label>
                  <input
                    type="text"
                    className="form-control"
                    name="simpanan"
                    value={editedData.simpanan || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Jasa %</label>
                  <input
                    type="text"
                    className="form-control"
                    name="jasa"
                    value={editedData.jasa || ""}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>No Perk</label>
                  <input
                    type="text"
                    className="form-control"
                    name="noperk"
                    value={editedData.noperk || ""}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-secondary" onClick={() => setShowEditModal(false)}>
                  Batal
                </button>
                <button className="btn btn-primary" onClick={handleSave}>
                  Simpan
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SetJasaManasuka;
